import { put, call } from 'redux-saga/effects';
import {
    authSignInSuccessAction,
    authSignInFailureAction,
    authVerifySignInFailureAction,
    authVerifySignInSuccessAction,
    authLogoutSuccessAction,
    authLogoutFailureAction,
    changeHospitalSuccessAction,
    changeHospitalFailureAction,
} from '../actions/loginActions';
import { END_POINTS } from '../../api/endpoints';
import { API } from '../../api/api';

// ------ Sign in ------

export function* authSignIn(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const signinResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.login}`,
            {
                phone: action.payload.phone,
                platform: action.payload.platform,
                countryCode: action.payload.countryCode
            },
        );
        
        if (signinResponse.success) {
            yield put(authSignInSuccessAction(signinResponse.data, {}));
        }
        else {
            throw new Error(signinResponse.message)
        }
    } catch (error) {
        yield put(authSignInFailureAction(error.message));
    }
}

// ------ verify sign in  --------

export function* authVerifySignIn(action) {
    let otp = action.payload.otp
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const verifyResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.verifyOtp}`,
            {
                phone: action.payload.phone,
                platform: action.payload.platform,
                countryCode: action.payload.countryCode,
                otp,
            },
        );
        if (verifyResponse.success) {
            yield put(authVerifySignInSuccessAction(verifyResponse.data));
        }
        else {
            throw new Error(verifyResponse.message)
        }

    } catch (error) {
        yield put(authVerifySignInFailureAction(error.message));
    }
}

export function* authSignout() {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const logoutResponse = yield call(
            API.post,
            `${baseUrl}${END_POINTS.logout}`
        );
        if (logoutResponse.success) {
            yield put(authLogoutSuccessAction());
            localStorage.clear();
            setTimeout(() => {
                window.location.href = "/";
            }, 200);
        }
        else {
            throw new Error(logoutResponse.message)
        }

    } catch (error) {
        yield put(authLogoutFailureAction(error.message));
    }
}

// ------ change hospital --------

export function* changeHospital(action) {
    try {
        let baseUrl =
            process.env.NODE_ENV === 'development'
                ? process.env.REACT_APP_DEVELOP
                : process.env.REACT_APP_PROD;
        const verifyHospital = yield call(
            API.post,
            `${baseUrl}${END_POINTS.changeHospital}`,
            {
                "hospitalId": action.payload.hospitalId
            }
        );
        if (verifyHospital.success) {
            yield put(changeHospitalSuccessAction(verifyHospital.data));
        }
        else {
            throw new Error(verifyHospital.message)
        }

    } catch (error) {
        yield put(changeHospitalFailureAction(error.message));
    }
}